import { render, staticRenderFns } from "./cad-alignmet.vue?vue&type=template&id=35be5df7&scoped=true"
import script from "./cad-alignmet.vue?vue&type=script&lang=js"
export * from "./cad-alignmet.vue?vue&type=script&lang=js"
import style0 from "./cad-alignmet.vue?vue&type=style&index=0&id=35be5df7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35be5df7",
  null
  
)

export default component.exports